import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .quest {
    display: flex;

    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    height: 4rem;
    width: 100%;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    cursor: pointer;

    margin-top: 1rem;

    p {
      font-size: 1.2rem;
      color: #a8a8a8;
    }

    div {
      display: flex;
      gap: 1rem;
    }

    .img {
      width: 2.5rem;
      height: 2.5rem;

      color: #898989;
      background-color: rgba(188, 188, 188, 0.3);

      padding: 0.5rem;
      border-radius: 50%;
    }
  }

  .sub-wrapper {
    display: flex;

    width: 100%;
  }

  .input-wrapper {
    display: flex;

    width: 100%;
    height: 10rem;

    justify-content: space-around;
    align-items: center;

    .select-wrapper {
      display: flex;
      flex-direction: column;

      width: 45%;

      font-size: 1.2rem;
      gap: 0.5rem;
    }

    .select-title {
      color: #2d7bbc;
    }
  }
`;
